import { useEffect } from 'react';
import { PagesPaths } from '@/enums';

const pagesWithCaptcha: string[] = [
  PagesPaths.SignUp,
  PagesPaths.EIR,
  PagesPaths.EInvoice,
];

const useReCaptchaVisibility = (currentPathname: string, isLogged: boolean) => {
  useEffect(() => {
    let style: HTMLStyleElement;

    if (isLogged || !pagesWithCaptcha.includes(currentPathname)) {
      style = document.createElement('style');
      style.innerHTML = `.grecaptcha-badge { visibility: hidden; }`;
      document.head.appendChild(style);
    } else {
      style = document.createElement('style');
      style.innerHTML = `.grecaptcha-badge { visibility: visible; }`;
      document.head.appendChild(style);
    }

    return () => {
      if (style) {
        document.head.removeChild(style);
      }
    };
  }, [currentPathname, isLogged]);
};

export default useReCaptchaVisibility;
